<template>
  <v-dialog v-model="$termos.open_termos" fullscreen persistent scrollable>
    <v-card>
      <v-card-title>
        {{ $termos.termos_lojista.descricao }}
      </v-card-title>
      <v-card-text v-html="$termos.termos_lojista.texto"></v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="hasAcceptTerms"
          @click="closed"
          :disabled="disabledButton"
          text
        >
          Fechar
        </v-btn>
        <v-btn
          v-else
          @click="handleYes"
          :disabled="disabledButton"
          color="tertiary"
          dark
        >
          Eu li e concordo com os termos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalTermos",
  props: {
    disabledButton: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["isAffiliate"]),
    hasAcceptTerms() {
      if (
        this.$axios.getCookie("oe_jwt") &&
        this.$axios.getLocal("oe_user_info") &&
        !this.isAffiliate
      ) {
        const { user_type, status } = this.$axios.getLocal("oe_user_info").data;
        if (
          (status !== "ACEITE_TERMOS" && user_type === "loja") ||
          (status === "ACEITE_TERMOS" && user_type === "admin")
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    closed() {
      this.$termos.open_termos = false;
    },
    closeModal() {
      this.$config.modalConfirm = false;
    },
    handleYes() {
      this.$termos.aceiteTermosLojista();
    },
  },
};
</script>
<style scoped></style>
